import React, { useEffect, useState } from "react";
import { priceCommaSeparator } from "../../../utils";
import BodyTemplate from "../BodyTemplate";
import Heading from "../BodyTemplate/Heading";
import {
  PartnerBox,
  PartnerItem,
  ImageDiv,
  ImageBox,
  ImageHolder,
  PartnerTitle,
  PartnerDetailBox,
  PartnerLocation,
  PartnerPriceBox,
  Price,
  Currency,
  CtaBox,
  CtaBtn,
  MiddleBox,
  Tag,
  TagIcon,
} from "./partnerStyle";

function PartnerSelector(
  {
    data = {},
    width,
    partnerList,
    handleCTAClick = () => {},
    isLoading = false,
    inlineForm,
  },
  ref
) {
  const [clickedCTA, setClickCTA] = useState(null);

  useEffect(() => {
    setClickCTA(null);
  }, [partnerList]);

  return (
    <BodyTemplate
      p={width > 1079 ? "38px 40px 0px" : "22px 0px 0px"}
      isLastSection={!inlineForm}
    >
      <Heading data={data} />
      {partnerList?.length > 0 && (
        <PartnerBox>
          {partnerList?.map((item, index) => {
            const metaTags = item?.meta_tag && JSON.parse(item?.meta_tag);
            return (
              <PartnerItem key={index}>
                {item.logo && (
                  <ImageDiv>
                    <ImageBox>
                      <ImageHolder src={item.logo} />
                    </ImageBox>
                  </ImageDiv>
                )}
                <MiddleBox>
                  <PartnerDetailBox>
                    {item.title && (
                      <PartnerTitle variant="heading5">
                        {item.title}
                      </PartnerTitle>
                    )}
                    {item.location && (
                      <PartnerLocation variant="label1">
                        {item.location}
                      </PartnerLocation>
                    )}
                  </PartnerDetailBox>
                  <PartnerPriceBox>
                    <Currency
                      fontSize="14px"
                      variant="label3"
                      lineHeight="32px"
                    >
                      {item.currency}
                    </Currency>
                    <Price variant="heading3">
                      {priceCommaSeparator(item?.pkg_price, 1, ",")}
                    </Price>
                  </PartnerPriceBox>
                </MiddleBox>
                {item.form_button_text && (
                  <CtaBox>
                    <CtaBtn
                      variant="primary1"
                      fontSize={["14px", "15px", "16px"]}
                      fontFamily="var(--man-700)"
                      disabled={
                        (index === clickedCTA && inlineForm) ||
                        (index === clickedCTA && isLoading)
                      }
                      isLoading={index === clickedCTA && isLoading}
                      onClick={() => {
                        if (index !== clickedCTA || !inlineForm) {
                          setClickCTA(index);
                          handleCTAClick(item);
                        }
                      }}
                    >
                      {item.form_button_text}
                    </CtaBtn>
                  </CtaBox>
                )}
                {metaTags && (
                  <Tag
                    variant="paragraph3"
                    fontSize={["12px", "14px", "16px"]}
                    isExtraBold
                    color={metaTags?.textColor}
                    backgroundColor={metaTags?.backgroundColor}
                  >
                    {metaTags?.icon && <TagIcon src={metaTags?.icon} />}
                    {metaTags?.text}
                  </Tag>
                )}
              </PartnerItem>
            );
          })}
        </PartnerBox>
      )}
    </BodyTemplate>
  );
}

export default React.forwardRef(PartnerSelector);
